import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  OnInit,
  Output,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { IRadioGroup } from '@nibtravel/shared/ui/forms/radio-group';
import { QuoteType } from '@nibtravel/shared/util/models';
import { QuoteActions, QuoteState } from '@nibtravel/shared/data-access/quote';
import { Qqc } from '@nibtravel/shared/util/e2e';

/**
 * Feature responsible for toggling different types of QQC.
 * At the moment, we are hard-cording this so the user can choose
 * between Single or AMT trips. However, some brands may not have amt or may
 * even have another trip type. e.g.: nib has inbound
 *
 * In addition, when brand only has one trip type, the selector
 * shouldn't be displayed on UI, but should still provide the value
 * on what type of qqc to show.
 *
 * @export
 * @class TripSelectorComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'nibtravel-trip-selector',
  template: `
    <nibtravel-radio-group
      [radioGroup]="tripTypeConfig"
      (checked)="onSelected($event)"
    ></nibtravel-radio-group>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripSelectorComponent implements OnInit {
  @HostBinding('class') hostClass = 'qqc-trip-selector';
  /** The event responsible for telling the current selected trip type */
  @Output() tripSelected = new EventEmitter();
  tripTypeConfig!: IRadioGroup;
  quoteType = this.store.selectSnapshot(QuoteState.quoteType);
  e2eId = Qqc;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.setTripTypeConfig();
  }

  /** Builder for the radio selector, this will need to be dynamic */
  setTripTypeConfig(): void {
    this.tripTypeConfig = {
      hostId: 'triptype',
      label: 'Trip type',
      groupName: 'tripType',
      data: [
        {
          inputId: 'trip-id-1',
          name: 'single-trip',
          label: 'Single Trip',
          labelId: 'trip-label-id-1',
          value: QuoteType.SingleTrip,
          checked: this.quoteType === QuoteType.SingleTrip,
          e2eId: this.e2eId.SingleTripSelector,
        },
        {
          inputId: 'trip-id-2',
          name: 'annual-multiple-trip',
          label: 'Annual Multi Trip',
          labelId: 'trip-label-id-2',
          value: QuoteType.MultiTrip,
          checked: this.quoteType === QuoteType.MultiTrip,
          e2eId: this.e2eId.AnnualMultipleTripSelector,
        },
      ],
    };
  }

  /** Event handler for the trip selector */
  onSelected(value: QuoteType): void {
    this.tripSelected.emit(value);
    this.store.dispatch(new QuoteActions.SetQuoteType(value));
  }
}
